export default "__VITE_ASSET__CCs3bkGY__"